import React from 'react';
import { NavLink } from 'react-router-dom';

interface ICdsHeaderNavItem {
  to: string;
  children?: React.ReactNode;
  exact?: boolean;
  external?: boolean;
  dropdown?: boolean;
  sidebar?: boolean;
}

function getClassname(dropdown: boolean, sidebar: boolean) {
  if (dropdown) return '';
  if (sidebar) return 'cds-nav-link sidebar-item'; //'p-md-0 py-md-4 d-md-block';
  return 'cds-nav-link';
}

const CdsHeaderNavLink = (props: ICdsHeaderNavItem) => {
  const className = getClassname(
    props.dropdown || false,
    props.sidebar || false
  );

  const link = props.external ? (
    <a href={props.to} className={className} target='_blank' rel='noreferrer'>
      <span>{props.children}</span>
    </a>
  ) : (
    <NavLink
      className={className}
      to={props.to}
      exact={props.exact}
      draggable={false}
    >
      <span>{props.children}</span>
    </NavLink>
  );
  return <li className={props.sidebar ? 'd-md-block' : ''}>{link}</li>;
};

export default CdsHeaderNavLink;
